import axios from 'axios';
import {backendHost} from '../../config';

export const postPromoStatus = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/promo/status`, params);
};